<script>

	import Layout from '@layouts/main'
	import appConfig from '@src/app.config'
	import api from '@/odooapi'
	import rpc from '@/odoorpc'
	import or from 'vuelidate/lib/validators/or'



	/**
	 * Dashboard-1 Component
	 */
	export default {
		page: {
			title: '工装管理',
			meta: [{
				name: 'description',
				content: appConfig.description
			}],
		},
		components: {
			Layout,
		},
		data() {
			return {
				showSearch:true,
				queryParams:{
					name:undefined,
					// product_tmpl_name:undefined
				},
				toolList:[],
				paginationData:{
					// 总数据条数
					total:0,
					// 当前页
					currentPage:1,
					// 每页展示几条数据
					page_Size:10,
				}
			}
		},
		created(){
			this.getData()
		},
		methods:{
			getData(){
				rpc.web.dataset.call_kw({
					model:'maintenance.equipment',
					method:'search_maintenance_equipment_partner',
					args:[],
					kwargs:{
						"currentPage":this.paginationData.currentPage,
						"pageSize":this.paginationData.page_Size,
						"name":this.queryParams.name
					}
				})
				.then(res=>{
					this.toolList = res.data
					this.paginationData.total = res.total
				})
			},
			// 搜索按钮
			handleQuery(){
				if(!this.queryParams.name){
					this.paginationData.currentPage = 1
					
				}
				this.getData()
			},
			// 重置按钮
			resetQuery(){
				this.queryParams.name = ""
				this.paginationData.currentPage = 1
				this.getData()
			},
			 // 分页
			handlePageSize(page_size){
				this.paginationData.page_Size=page_size
				// 这里写获取的的方法
				this.getData()

			},
			handlePageChange(pageNum){
				this.paginationData.currentPage=pageNum
				// 这里写获取的的方法
				this.getData()
			},
		}
	}
</script>

<template>
	<Layout>
		<div class="row page-title align-items-center">
			<div class="col-sm-4 col-xl-6">
				<h4 class="mb-1 mt-0">工装管理</h4>
			</div>
			<div class="col-sm-8 col-xl-6">
				<form class="form-inline float-sm-right mt-3 mt-sm-0">
					<!-- <div class="form-group mb-sm-0 mr-2">
						<flat-pickr v-model="selectedDate" class="form-control" :config="dateConfig" name="date">
						</flat-pickr>
					</div> -->
					<div class="btn-group">
						<!-- <b-dropdown variant="primary" right>
							<template v-slot:button-content>
								<i class="uil uil-file-alt mr-1"></i>Download
								<i class="icon">
									<feather type="chevron-down" class="align-middle"></feather>
								</i>
							</template>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="mail" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Email</span>
							</b-dropdown-item>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="printer" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Print</span>
							</b-dropdown-item>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item href="#" class="notify-item">
								<feather type="file" class="icon-dual icon-xs mr-2 align-middle"></feather>
								<span>Re-Generate</span>
							</b-dropdown-item>
						</b-dropdown> -->
					</div>
				</form>
			</div>
		</div>

    <div class="row">
      <div class="col">
		<div class="card">
			<div class="card-body p-0">
				<el-form :model="queryParams" ref="queryForm" v-show="showSearch" :inline="true" class="p-3">
					<!-- <el-form-item label="设备编码" prop="name">
						<el-input v-model="queryParams.name" placeholder="请输入设备编码" clearable size="small"
								style="width: 240px" @keyup.enter.native="handleQuery"/>
					</el-form-item> -->
					<el-form-item label="设备名称" prop="name">
						<el-input v-model="queryParams.name" placeholder="请输入设备名称" clearable size="small"
								style="width: 240px" @keyup.enter.native="handleQuery"/>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
						</el-button>
						<el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>

				<div style="margin-top: -0.6rem;">
					<el-table :data="toolList" style="width: 100%" class="p-3">
						<el-table-column type="selection" width="55" align="center"/>
						<!-- <el-table-column prop="partner_name" label="客户"/> -->
						<el-table-column prop="name" label="设备名称"/>
						<el-table-column prop="assign_date" label="分配日期"/>
						<el-table-column prop="warehouse_name" label="所属工厂"/>
						<el-table-column prop="category_name" label="设备类别"/>
					</el-table>
				</div>

				<el-pagination
					background
					style="margin-top: 20px; text-align: right;"
					layout="total, sizes, prev, pager, next, jumper"
					:total="paginationData.total"
					:current-page="paginationData.currentPage"
					:page-size="paginationData.page_Size"
					:page-sizes="[10, 30, 50]"
					@size-change="handlePageSize"
					@current-change="handlePageChange"
					>
				</el-pagination>

			</div>
		</div>
	  </div>
    </div>
	</Layout>
</template>
